import { render } from "./RegistrationDeedForm.vue?vue&type=template&id=5785e500&scoped=true"
import script from "./RegistrationDeedForm.vue?vue&type=script&lang=js"
export * from "./RegistrationDeedForm.vue?vue&type=script&lang=js"

import "./RegistrationDeedForm.vue?vue&type=style&index=0&id=5785e500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5785e500"]])

export default __exports__